import { PageHeader } from '@/shared/ui';
import patterns from '@/shared/ui/styles/patterns.module.css';
import { LocationCredentialsCard } from '../components/LocationCredentialsCard';
import { ProviderCredentialsTable } from '../components/ProviderCredentialsTable';
import { SetupReadinessBanner } from '../components/SetupReadinessBanner';

export function PracticeCredentialsPage() {
  return (
    <div className={patterns.page}>
      <PageHeader
        title="Practice Credentials"
        subtitle="How this location identifies itself to insurance companies. The AI agent authenticates with these exact values on every payer call."
      />
      <SetupReadinessBanner />
      <LocationCredentialsCard />
      <ProviderCredentialsTable />
    </div>
  );
}
